import React, { useState } from "react";

interface Props {
  type: "success" | "error";
  title: string;
  subtitle?: string;
  details?: string;
}

export function Notification({ type, title, subtitle, details }: Props) {
  const [showDetails, setShowDetails] = useState(false);

  if (type === "success") {
    return (
      <div className="flex bg-[#ebf9eb] text-[#1e611e]">
        <div className="bg-[#3CC13B] pt-[6px] px-[10px]">
          <i className="fa-regular fa-sharp fa-sharp fa-check text-[#fff] text-[14px]"></i>
        </div>
        <div className="p-[8px]">
          <h4 className="font-bold text-sm m-0 p-0">{title}</h4>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex bg-[#f9ebeb] text-[#611e1e]">
        <div className="bg-[#de4444] pt-[6px] px-[12px]">
          <i className="fa-regular fa-sharp fa-xmark text-[#fff] text-[16px]"></i>
        </div>
        <div className="p-[8px]">
          <h4 className="font-bold text-sm m-0 p-0">{title}</h4>
          {subtitle && <div className="text-xs mt-1 mb-3">{subtitle}</div>}
          {details && (
            <div className="text-xs font-light">
              {!showDetails && (
                <button
                  className="font-light underline hover:text-[#230a0a]"
                  onClick={() => setShowDetails(true)}
                >
                  Show details
                </button>
              )}
              {showDetails && details}
            </div>
          )}
        </div>
      </div>
    );
  }
}
